/** Sort field names accepted by the Users Service batch-get/list APIs — shared by every UI table that sorts by user name/email/status (Users page, Group Members drawer, etc.). */
export const USER_SORT_FIELD = {
    Name: "name",
    Email: "emailId",
    Status: "status",
} as const;

export type UserSortField = (typeof USER_SORT_FIELD)[keyof typeof USER_SORT_FIELD];

/** Filter field names accepted by the Users Service query APIs — shared by every UI table that filters by user name/email/status (Users page, Group Members drawer, etc.). */
export const USER_FILTER_FIELD = {
    Name: "name",
    Email: "email",
    Status: "status",
} as const;

export type UserFilterField = (typeof USER_FILTER_FIELD)[keyof typeof USER_FILTER_FIELD];
